/**
 * Статусы из ручки видиохостингов
 * @type {Object}
 */

module.exports = {
    STATUS_DELETED: 'deleted',
    STATUS_DISABLED: 'disabled',
    STATUS_DRM: 'drm',
    STATUS_HAS_CACHUP: 'has_cachup',
    DEFAULT_CHANNEL_FAMILY_ID: 367,
    DEFAULT_CHANNEL_TRANSLITERATED: 'semeynye-komedii-367',
    PREFIX_TOUCH: 'touch_',
    PREFIX_DESKTOP: 'desk_',
    EFIR_URL: 'https://yandex.ru/efir',
};
